// src/components/ROSelect.js
import React from "react";
import { useRO } from "../Dashboards/ROContext";

export default function ROSelect({ className, theme = "dark" }) {
  const { roList, selectedRoId, setSelectedRoId, loading } = useRO();

  const handleChange = (e) => {
    const value = e.target.value || null;
    setSelectedRoId(value);
    if (value) {
      localStorage.setItem("selectedRoId", value);
    }
  };
const isLight = theme === "light";
  return (
    <fieldset
      className={className}
      style={{
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: "6px 10px 8px",
        minWidth: 220,
      }}
    >
      <legend
        style={{
          padding: "0 6px",
          fontSize: "12px",
          fontWeight: 500,
         color: isLight ? "#000" : "#fff", // header text color
        }}
      >
        Select RO
      </legend>

      <select
        value={selectedRoId || ""}
        onChange={handleChange}
        disabled={loading || roList.length === 0}
        style={{
          width: "100%",
          border: "none",
          outline: "none",        // 🔥 no blue focus
          background: "transparent",
          color: isLight ? "#000" : "#fff", // 🔥 label color
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        {roList.map((ro) => (
          <option key={ro.id} value={String(ro.id)} style={{ color: "#000" }}>
            {ro.ro_name || ro.name || `RO ${ro.id}`}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
